import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from '@emotion/styled';
import { B200, N0, N10, N100, N200, N900, R400 } from '@atlaskit/theme/colors';
import { fontFamily, fontSize, gridSize } from '@atlaskit/theme/constants';
import { headingSizes } from '@atlaskit/theme/typography';
import { FormGrid } from '../../../common/ui/FormGrid/styled';
export { FormGrid };
export var ErrorWrapper = styled.span({
  fontSize: "".concat(fontSize(), "px")
});
export var Label = styled.label({
  fontSize: "".concat(headingSizes.h200.size / fontSize(), "em"),
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  fontWeight: 600,
  display: 'block'
});
export var LabelSpan = styled.span({
  display: 'block',
  marginBottom: "var(--ds-space-050, 4px)"
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation
export var Field = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-color: ", ";\n  border-radius: 3px;\n  border-width: ", ";\n  border-style: solid;\n  box-sizing: border-box;\n  transition:\n    background-color 0.2s ease-in-out,\n    border-color 0.2s ease-in-out;\n  padding: ", "px ", ";\n  &:focus-within {\n    border-color: ", ";\n    box-shadow: inset 0 0 0 ", "\n      ", ";\n  }\n"])), function (_ref) {
  var focused = _ref.focused;
  return focused ? "var(--ds-background-input-pressed, ".concat(N0, ")") : "var(--ds-background-input, ".concat(N10, ")");
}, function (_ref2) {
  var focused = _ref2.focused,
    error = _ref2.error;
  if (error) {
    return focused ? "var(--ds-border-focused, ".concat(B200, ")") : "var(--ds-border-danger, ".concat(R400, ")");
  } else {
    return focused ? "var(--ds-border-focused, ".concat(B200, ")") : "var(--ds-border-input, ".concat(N100, ")");
  }
}, "var(--ds-border-width, 1px)", gridSize() + 2, "var(--ds-space-075, 6px)", "var(--ds-border-focused, ".concat(B200, ")"), "var(--ds-border-width, 1px)", "var(--ds-border-focused, ".concat(B200, ")"));
export var inputOptions = {
  style: {
    base: {
      // this style will be used in another iframe with different base settings
      // we have to use absolute, body-styles independent units
      fontSize: "".concat(headingSizes.h400.size, "px"),
      color: "var(--ds-text, ".concat(N900, ")"),
      fontFamily: fontFamily(),
      '::placeholder': {
        color: "var(--ds-text-subtlest, ".concat(N200, ")")
      }
    },
    invalid: {
      color: "var(--ds-text-danger, ".concat(R400, ")")
    }
  }
};